import { useCallback } from 'react'
import {
  searchFirstBiteCompanies,
  searchUnmatchedCompanies,
  searchFirstBiteDoors,
  searchUnmatchedDoors,
} from '../../../services/search'
import {
  ContactCompanySearchResult,
  DoorSearchResult,
} from '../../../models/companies'

export type SearchType =
  | 'fb_location'
  | 'fb_company'
  | 'custom_location'
  | 'custom_company'

export interface SearchOptions {
  category_filter?: string
  type_filter?: string
  city_filter?: string
  state_filter?: string
  zipcode_filter?: string
  sort_by?: string
  limit?: number
  offset?: number
}

export interface SearchResponse {
  results: (ContactCompanySearchResult | DoorSearchResult)[]
  total: number
  search_type?: string
}

export const useMobileSearchAPI = () => {
  const performSearch = useCallback(
    async (
      searchType: SearchType,
      query: string,
      options: SearchOptions = {},
      signal?: AbortSignal
    ): Promise<SearchResponse> => {
      if (!query || query.length < 2) {
        return { results: [], total: 0 }
      }

      try {
        switch (searchType) {
          case 'fb_location':
            return await searchFirstBiteDoors(query, options, signal)

          case 'fb_company':
            return await searchFirstBiteCompanies(query, options, signal)

          case 'custom_location':
            return await searchUnmatchedDoors(query, options, signal)

          case 'custom_company':
            return await searchUnmatchedCompanies(query, options, signal)

          default:
            return { results: [], total: 0 }
        }
      } catch (error) {
        // If the error is an abort error, don't throw
        if (error instanceof Error && error.name === 'AbortError') {
          return { results: [], total: 0 }
        }
        throw error
      }
    },
    []
  )

  return { performSearch }
}
